/* #2 絞り込みモーダルのスクロール位置保持（Issue#107・v2）
   Boostはチェックのたびにフィルターを再描画し、そのパネルを先頭へ戻す。
   スクロールしている要素はコレクション/端末で異なるため決め打ちせず、
   「押されたチェックの実際のスクロール祖先」を動的に特定して退避→再描画後に復元する。
   Boost内部は非改変（復元するだけ）。効かなくても絞り込み自体は壊れない。 */
(function(){
  "use strict";
  var SEL = '.boost-pfs-filter-option-item-list-multiple-list li,'+
            '.boost-pfs-check-box, .boost-pfs-filter-option-item,'+
            '.boost-pfs-filter-multiple-option, .boost-pfs-filter-option-item-label';

  function esc(s){ try { return (window.CSS && CSS.escape) ? CSS.escape(s) : s.replace(/([^\w-])/g,'\\$1'); } catch(_){ return s; } }
  function selectorFor(el){
    if (el.id) return '#'+esc(el.id);
    var c = (el.className||'').toString().trim().split(/\s+/).filter(Boolean);
    return c.length ? '.'+c.map(esc).join('.') : null;
  }
  // 押された要素から上へ辿り、実際にスクロールしている祖先を全部退避
  function capture(opt){
    var targets = [], el = opt;
    while (el && el !== document.body && el !== document.documentElement){
      if (el.scrollHeight > el.clientHeight + 4){
        var cs = window.getComputedStyle(el);
        if (/(auto|scroll)/.test(cs.overflowY) && el.scrollTop > 0){
          targets.push({ node: el, sel: selectorFor(el), top: el.scrollTop });
        }
      }
      el = el.parentElement;
    }
    return { targets: targets, win: window.scrollY || 0 };
  }
  function restore(p){
    p.targets.forEach(function(t){
      var node = t.node;
      // 再描画で要素ごと置換された場合はセレクタで取り直す
      if (!document.contains(node) && t.sel){
        try { node = document.querySelector(t.sel) || node; } catch(_){}
      }
      if (node && node.scrollHeight > node.clientHeight + 4){
        if (Math.abs(node.scrollTop - t.top) > 4) node.scrollTop = t.top;
      }
    });
    if (p.win > 4 && Math.abs((window.scrollY||0) - p.win) > 4) window.scrollTo(0, p.win);
  }

  document.addEventListener('click', function(e){
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest(SEL)) return;
    var opt = e.target.closest(SEL);
    var p = capture(opt);
    if (!p.targets.length && p.win <= 4) return;  // 退避すべき位置が無い（先頭）なら何もしない
    // Ajax再描画のタイミングが読めないため多段で復元
    [20,60,120,220,350,520,750].forEach(function(t){ setTimeout(function(){ restore(p); }, t); });
    // 再描画（DOM変化）の直後に確実に戻す。押下から1.1秒だけ監視。
    var mo;
    try {
      mo = new MutationObserver(function(){ restore(p); });
      mo.observe(document.body, { childList:true, subtree:true });
      setTimeout(function(){ try { mo.disconnect(); } catch(_){} }, 1100);
    } catch(_){}
  }, true);
})();
